import { useQuery } from '@apollo/client';
import { useMemo } from 'react';

import {
  BulkPatientItemDataFragment,
  GetBulkPatientsDocument,
  GetBulkPatientsQueryVariables,
} from '../../types/api/graphql';

const useBulkPatientItems = (variables: GetBulkPatientsQueryVariables) => {
  const { data: bulkPatientItemsData, loading: bulkPatientItemsDataLoading } =
    useQuery(GetBulkPatientsDocument, {
      variables: {
        ...variables,
      },
      skip: !variables.id,
    });
  const data = useMemo(
    () =>
      (bulkPatientItemsData?.bulkCampaignPatients?.items ??
        []) as BulkPatientItemDataFragment[],
    [bulkPatientItemsData?.bulkCampaignPatients]
  );

  return {
    data,
    loading: bulkPatientItemsDataLoading,
  };
};

export { useBulkPatientItems };
